module.exports = __webpack_public_path__ + "static/media/Logo.5f5bd2c7.svg";